import React, { useEffect, useState } from "react";
import { Input, Typography, Button, Spin, Form, notification } from "antd";
import { get, post } from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";

const { Title } = Typography;

const ListingsPortalSettings = () => {
  const navigate = useNavigate();

  const [fromLoading, setFromLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputsValue, setInputsValue] = useState([]);
  const [initValues, setInitValues] = useState({});

  useEffect(() => {
    get("listing-settings").then((res) => {
      setInputsValue(res.data.data);
      const initValuesNew = {};
      res.data.data.forEach((item) => {
        initValuesNew[item.key] = item.value;
      });

      setInitValues(initValuesNew);
      setFromLoading(true);
    });
  }, []);

  const onFinish = (values) => {
    setLoading(true);

    const newArr = [];
    Object.keys(values).forEach((key) => {
      const newObj = { key, value: values[key] };

      newArr.push(newObj);
    });

    post("listing-settings", { settings: newArr })
      .then(() => {
        notification.success({ message: "Modified successfully" });
        setLoading(false);
        navigate("/listings-portal-settings");
      })
      .catch((err) => {
        notification.error({
          message: "Error!",
          description: err.response?.data?.message || "Unknown error",
        });
        setLoading(false);
      });
  };

  return (
    <div>
      <Title level={2} className="text-main mb-2">
        Listings Portal Settings
      </Title>
      {fromLoading ? (
        <Form
          className="wrapper-content"
          onFinish={onFinish}
          layout="vertical"
          autoComplete="off"
          initialValues={initValues}
        >
          <div className="row">
            {inputsValue.map((item) => (
              <div className="col-lg-6" key={item.key}>
                <Form.Item
                  label={item.name}
                  name={item.key}
                  rules={[
                    {
                      required: true,
                      message: "This field is required!",
                    },
                  ]}
                >
                  <Input placeholder="Type..." type={item.type} />
                </Form.Item>
              </div>
            ))}
          </div>
          {checkPermission("edit-listing-settings") && (
            <div className="row">
              <div className="col-lg-4 offset-lg-4">
                <Form.Item
                  wrapperCol={{
                    offset: 1,
                    span: 16,
                  }}
                >
                  <Button
                    loading={loading}
                    size="large"
                    block
                    type="primary"
                    htmlType="submit"
                  >
                    {loading ? "Saving..." : "Save"}
                  </Button>
                </Form.Item>
              </div>
            </div>
          )}
        </Form>
      ) : (
        <div className="text-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default ListingsPortalSettings;
